(function() {
  'use strict';

  angular.module('ringbaPortal').component('ivrRouterNodeFooter', {
    bindings: {
      node: '<',
      onAddNodeToTree: '<',
      onRemoveNode: '<',
      onAddingNodeBegin: '<',
      onAddingNodeComplete: '<',
      nodeTypes: '<',
      ivrTree: '<',
      updateLink: '<'
    },
    controller: IvrRouterNodeController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/ivr/ivr-router-node-footer.view.html'
  });

  function IvrRouterNodeController(
    _,
    $filter,
    $timeout,
    bsLoadingOverlayService,
    ivrService
  ) {
    'ngInject';

    const vm = this;

    vm.highlightSelectedNodeType = {};

    vm.$onChanges = onChanges;
    vm.$onInit = onInit;
    vm.removeChildNode = removeChildNode;
    vm.addNode = addNode;
    vm.showFilterPopover = showFilterPopover;
    vm.hideFilterPopover = hideFilterPopover;
    vm.onRouterLinkSorted = onRouterLinkSorted;

    function onInit() {
      // This object will be used to show/hide the filter popover in links in Router Nodes
      vm.filterPopoverStatus = {};
    }

    function onChanges(changes) {
      if (changes.node) {
        vm.internalNode = angular.copy(vm.node);

        _showNewLinkFilterPopover(changes.node);

        _.forOwn(vm.internalNode.childLinksLookup, function(child) {
          child.iconCssClass = ivrService.getNodeTypeIcon(child.childNodeType);
        });
      }
    }

    function removeChildNode(node, $routerChildIndex) {
      const toUpdateChildLinksNames = [];

      for (let i = $routerChildIndex + 1; i < vm.internalNode.childLinks.length; i++) {
        toUpdateChildLinksNames.push({ newIndex: i - 1, childLink: vm.internalNode.childLinks[i] });
      }

      vm.onRemoveNode({
        id: node.childNodeId
      }, toUpdateChildLinksNames, vm.internalNode.id);
    }

    function addNode(nodeType) {
      if (!vm.disableNodeTypesButtons) {
        vm.onAddingNodeBegin(nodeType.nodeType);
        const newLinkName = 'Route ' + (vm.internalNode.childLinks.length + 1);
        vm.onAddNodeToTree(vm.internalNode.id, nodeType.nodeTypeId, newLinkName, true, [], function () {
          vm.onAddingNodeComplete(nodeType);
          vm.isRouterNodePotentialLinksPopoverOpen = false;
        });
      }
    }

    function showFilterPopover(linkId) {
      if (vm.filterPopoverStatus[linkId]) {
        hideFilterPopover(linkId);
      } else {
        _hideAllFilterPopovers();
        vm.filterPopoverStatus[linkId] = true;
      }
    }

    function hideFilterPopover(linkId) {
      vm.filterPopoverStatus[linkId] = false;
    }

    function onRouterLinkSorted(ev) {
      $timeout(function () {
        const removedElement = vm.internalNode.childLinks.splice(ev.oldIndex, 1)[0];
        vm.internalNode.childLinks.splice(ev.newIndex, 0, removedElement);

        vm.updateLink(vm.internalNode.childLinks[ev.newIndex].childNodeId, vm.internalNode.id, angular.copy(vm.internalNode.childLinks[ev.newIndex].criteria), ev.newIndex);
      }, 0);
    }

    // Show the filter popover when a new child link is added to a Router node
    function _showNewLinkFilterPopover(nodeChanges) {
      if (!nodeChanges.isFirstChange()
      && nodeChanges.previousValue && nodeChanges.previousValue.childLinks
      && nodeChanges.currentValue && nodeChanges.currentValue.childLinks
      && nodeChanges.currentValue.childLinks.length > nodeChanges.previousValue.childLinks.length) {
        _.forEach(_.differenceBy(nodeChanges.currentValue.childLinks, nodeChanges.previousValue.childLinks, 'childNodeId'),
          function (link) {
            showFilterPopover(link.childNodeId);
          });
      }
    }

    function _hideAllFilterPopovers() {
      const linkId = _.findKey(vm.filterPopoverStatus, true);
      if (linkId) {
        hideFilterPopover(linkId);
      }
    }
  }
})();
